<script setup lang="ts">
import AlertContainer from "@/components/AlertContainer.vue"
import ImportDialog from "@/components/FileImport/Dialog/Dialog.vue"
import Dropzone from "@/components/FileImport/Dropzone.vue"
import PlaygroundDialog from "@/components/FormulaPlayground/Dialog.vue"
import IntegrationDialog from "@/components/Integration/Dialog.vue"
import ReloadPrompt from "@/components/ReloadPrompt.vue"
import { useFileImportStore, useIntegrationStore, usePlaygroundStore } from "@/stores"
import { captureError } from "@/utils/useEngineModel"
import { DialogWrapper } from "vue3-promise-dialog"

const fileImportStore = useFileImportStore()
const integrationStore = useIntegrationStore()
const playgroundStore = usePlaygroundStore()

async function handleDropzoneFile(files: File[]) {
  try {
    await fileImportStore.handleFileUpload(files)
  } catch (error) {
    captureError(error, { snackbar: true })
  }
}
</script>

<template>
  <Suspense>
    <RouterView />
  </Suspense>
  <ReloadPrompt />
  <DialogWrapper />
  <Suspense>
    <ImportDialog v-if="fileImportStore.dialog" />
  </Suspense>
  <Suspense>
    <IntegrationDialog v-if="integrationStore.dialog" />
  </Suspense>

  <Suspense>
    <PlaygroundDialog v-if="playgroundStore.dialog" />
  </Suspense>

  <Dropzone @file-changed="handleDropzoneFile" />
  <AlertContainer />
  <div
    id="context-menu-wrapper"
    class="relative z-40"
  />
</template>
